/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import './Footer.css';
import { TbBrandGithub } from 'react-icons/tb';
import { RiLinkedinFill } from 'react-icons/ri';
import { AiOutlineInstagram } from 'react-icons/ai';

const Footer = () => {
  return (
    <footer>
      <a href="#" className='footer__logo'>Qurat Ul Ain Shoro</a>
      <ul className="permalinks">
        <li><a href="#">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Experience</a></li>
        <li><a href="#services">Services</a></li>
        <li><a href="#portfolio">Portfolio</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>

      <div className="footer__socials">
        <a href="https://github.com/QuratAin" target='_blank' rel="noreferrer"><TbBrandGithub className='footer__socials-icon' /></a>
        <a href="https://www.linkedin.com/in/quratulain-shoro-7792721a4/" target='_blank' rel="noreferrer"><RiLinkedinFill className='footer__socials-icon' /></a>
        <a href="https://www.instagram.com/q.aiin/" target='_blank' rel="noreferrer"><AiOutlineInstagram className='footer__socials-icon' /></a>
      </div>

      <div className="footer__copyright">
        <small>&copy; Qurat Ul Ain Shoro. All Rights Reserved.</small>
      </div>
    </footer>
  )
}

export default Footer
